import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Layouts from "./layouts/layout";
import rulesStyles from "./css/promoRules.module.css";

// ===================== M-PESA QUIZMASTER PROMO RULES =====================
// Content follows the official "Regulamento do Concurso" (Vodacom Moçambique).
// Each section: items → optional table → optional itemsAfter
const promoRulesText = {
  0: {
    pageTitle: "Contest Rules",
    title: "Win Money on M-Pesa with QuizMaster",
    dates: "15 Oct – 11 Nov 2026",
    back: "Back",
    play: "Play now",
    leaderboard: "Leaderboard",
    footer: "Participation implies knowledge and acceptance of these Rules.",
    sections: [
      {
        icon: "📋",
        heading: "1. General aspects",
        items: [
          "1.1. These Rules set out the conditions for taking part in the contest «Win Money on M-Pesa with QuizMaster» (the «Contest»), promoted by Vodacom Moçambique, S.A. («Vodacom» or the «Promoter»). QuizMaster is a Vodacom product, provided in partnership with Raimboo.",
          "1.2. QuizMaster is a digital question-and-answer service on general knowledge and other knowledge and entertainment topics, provided by Vodacom in partnership with Raimboo. Customers answer questions, collect Stars and can exchange them for benefits, under the usual conditions of the service. During the Contest, the Stars earned also allow customers to compete in the weekly and final rankings to win cash prizes on M-Pesa.",
          "1.3. The Contest is scheduled to start on 15 October 2026 at 00:00 and ends on 11 November 2026 at 23:59:59, Mozambique local time. For the purposes of these Rules, the promotional month is 28 days, divided into four consecutive seven-day weeks, according to the calendar below.",
        ],
        table: {
          head: ["Week", "Start", "End"],
          rows: [
            ["1", "15/10/2026 — 00:00", "21/10/2026 — 23:59:59"],
            ["2", "22/10/2026 — 00:00", "28/10/2026 — 23:59:59"],
            ["3", "29/10/2026 — 00:00", "04/11/2026 — 23:59:59"],
            ["4", "05/11/2026 — 00:00", "11/11/2026 — 23:59:59"],
          ],
        },
        itemsAfter: [
          "1.4. Participation implies knowledge and acceptance of these Rules. The Contest complements the usual QuizMaster mechanics; prices, additional packs, the public ranking and the normal exchange of Stars remain unchanged, under the terms of the service.",
        ],
      },
      {
        icon: "✅",
        heading: "2.1. Eligibility",
        items: [
          "2.1.1. Only active Vodacom Moçambique numbers are eligible to take part in the Contest. New and existing QuizMaster customers may take part, including customers returning to the service, provided they meet the participation conditions.",
          "2.1.2. Members of the teams directly involved in organising the Contest are not eligible.",
        ],
      },
      {
        icon: "📲",
        heading: "2.2. Registration and access",
        items: [
          "2.2.1. Participants can access the product through the link https://vmz.quizzzmaster.com or start a subscription by sending an SMS with the word «OK» to the short code 84636, following the service instructions.",
          "2.2.2. The access journey includes subscription or identification, login and validation through a one-time password (OTP), according to the flow provided by the service.",
          "2.2.3. After accessing, participants can answer the questions available on QuizMaster and follow their score and position on the weekly and final leaderboards, available inside the product.",
        ],
      },
      {
        icon: "💳",
        heading: "2.3. Price and payment methods",
        items: [
          "2.3.1. The QuizMaster daily subscription costs 3 MT, auto-renewing, and includes 20 questions per day.",
          "2.3.2. The QuizMaster weekly subscription costs 20 MT, auto-renewing.",
          "2.3.3. The QuizMaster monthly subscription costs 50 MT, auto-renewing.",
          "2.3.4. Participants can buy additional packs of 10 questions for 3 MT per pack.",
          "2.3.5. Payment can be made with Vodacom airtime balance or M-Pesa, for activation, renewal and the purchase of additional packs. The payment method chosen does not change the Stars awarded for answers.",
        ],
      },
      {
        icon: "🎮",
        heading: "2.4. How it works and scoring",
        items: [
          "2.4.1. The Contest takes place through QuizMaster, a digital knowledge and entertainment question service.",
          "2.4.2. Each correct answer is worth 10 Stars. Each incorrect answer is worth 1 star.",
          "2.4.3. For the Contest, the Stars earned during the respective ranking period are counted, including Stars from questions in additional packs.",
          "2.4.4. The normal QuizMaster Stars exchange remains available. The Contest uses the Stars earned in the relevant periods; the technical compatibility between Stars exchange and ranking records shall be confirmed before launch.",
        ],
      },
      {
        icon: "📊",
        heading: "2.5. Weekly ranking",
        items: [
          "2.5.1. The weekly ranking identifies the participants with the best score earned exclusively in the respective seven-day week, according to the calendar in clause 1.3. Stars earned in previous weeks do not count towards that week's ranking. The ranking restarts at the beginning of each new week.",
          "2.5.2. The five eligible participants with the highest score in each week are awarded prizes, according to the prize table and the repeat-winner rule.",
          "2.5.3. Each participant can win a maximum of two weekly prizes during the four weeks of the Contest and cannot win prizes in consecutive weeks.",
          "2.5.4. Being unable to receive a weekly prize under this rule does not prevent the participant from continuing to play and collect Stars for the final ranking.",
          "2.5.5. Procedure for awarding prizes when a participant in the ranking is not eligible, including passing to the next participant and the amount corresponding to the awarded position.",
        ],
      },
      {
        icon: "🏁",
        heading: "2.6. Final ranking",
        items: [
          "2.6.1. The final ranking identifies the participants with the highest accumulated score during the whole promotional month: from 15 October to 11 November 2026. It adds up the Stars earned in the four seven-day weeks and does not restart weekly.",
          "2.6.2. The three eligible participants with the highest accumulated score at the end of the Contest are awarded prizes.",
          "2.6.3. Weekly winners remain eligible for the final ranking. The two-prize limit and the ban on consecutive weeks apply to weekly prizes.",
          "2.6.4. Weekly winners and final winners may not be the same: the former are determined by performance in the respective week and the latter by accumulated performance during the whole promotional month of the campaign. An awarded position in one week does not guarantee an awarded position in the final ranking.",
        ],
      },
      {
        icon: "⚖️",
        heading: "2.7. Tie-break",
        items: [
          "2.7.1. In the event of a tie in the weekly or final ranking, the tie-break will be decided by response time, with priority given to the participant who answered fastest, according to QuizMaster records.",
          "2.7.2. Method for calculating response time and procedure if the tie persists under that criterion.",
        ],
      },
      {
        icon: "🧑‍⚖️",
        heading: "2.8. Decisions",
        items: [
          "2.8.1. The Promoter's decisions on the application of these Rules and the validation of results are final within the organisation of the Contest, without prejudice to the rights legally applicable to participants.",
          "2.8.2. Any question or complaint should be sent through Vodacom's official social media, the 84111 line or the address indicated in clause 9.",
        ],
      },
      {
        icon: "📣",
        heading: "2.9. Communication",
        items: [
          "2.9.1. Contest communications may be made by SMS, through QuizMaster and Vodacom's official channels. Rankings and winner announcements will be published through the channels defined by the Promoter.",
          "2.9.2. Participants must ensure their phone numbers are active and reachable to receive Contest-related communications.",
          "2.9.3. The deadline for contacting winners, number of attempts, response deadline and procedure for unreachable winners is 5 working days after publication.",
        ],
      },
      {
        icon: "🏅",
        heading: "2.10. Leaderboards in the product",
        items: [
          "2.10.1. QuizMaster will provide two separate leaderboards inside the product: a weekly one and a final one.",
          "2.10.2. The weekly leaderboard shows participants' scores and positions in the respective week. The final leaderboard shows the accumulated score and position of participants during the whole promotional month of the campaign, covering the four weeks.",
          "2.10.3. The awarding of prizes depends on participants' eligibility and the repeat-winner rules in these Rules, not only on the position shown on the leaderboard.",
        ],
      },
      {
        icon: "💰",
        heading: "3.1. Weekly prizes",
        items: [
          "3.1.1. In each of the four weeks, the following cash prizes will be awarded on M-Pesa:",
        ],
        table: {
          head: ["Position", "M-Pesa prize"],
          rows: [
            ["1st place", "5,000 MT"],
            ["2nd place", "3,000 MT"],
            ["3rd place", "2,000 MT"],
            ["4th place", "1,000 MT"],
            ["5th place", "500 MT"],
          ],
        },
        itemsAfter: [
          "3.1.2. The total weekly prizes amount to 11,500 MT per week, corresponding to 46,000 MT over the four weeks.",
        ],
      },
      {
        icon: "🏆",
        heading: "3.2. Final prizes",
        items: [
          "3.2.1. At the close of the Contest, the following cash prizes will be awarded on M-Pesa:",
        ],
        table: {
          head: ["Position", "M-Pesa prize"],
          rows: [
            ["1st place", "20,000 MT"],
            ["2nd place", "15,000 MT"],
            ["3rd place", "10,000 MT"],
          ],
        },
        itemsAfter: [
          "3.2.2. The total final prizes amount to 45,000 MT. The overall value of the Contest prizes is 91,000 MT.",
        ],
      },
      {
        icon: "📤",
        heading: "3.3. Delivery of prizes",
        items: [
          "3.3.1. Cash prizes will be sent to the winners' M-Pesa within one week (seven days) after the official announcement of the respective winners.",
        ],
      },
      {
        icon: "🚫",
        heading: "4. Exclusion from the challenge",
        items: [
          "4.1. The Promoter reserves the right to exclude any participant who defrauds, hinders, alters or disables the proper functioning and normal, regular course of the QuizMaster Contest, or who it reasonably believes has not complied with these Rules, and/or any participant who puts, or may put, at risk, directly or indirectly, the good name or reputation of Vodacom, its industrial property rights and/or its staff or employees.",
          "4.2. In any case, whether or not they have been excluded, participants are solely responsible for all their acts and omissions that are criminally punishable, unlawful, likely to cause damage or loss to third parties or that infringe their industrial, intellectual or other property rights during their participation in the QuizMaster Contest.",
          "4.3. Vodacom is not responsible for lost, late, incomplete, invalid, misdirected or corrupted entries, which will not be considered for participation in the Contest, without prejudice to legally applicable liabilities.",
          "4.4. Vodacom is not responsible for incomplete or failed electronic transmissions, or for technical failures of any kind, including but not limited to the malfunction of any network, hardware or software, without prejudice to legally applicable liabilities.",
          "4.5. For the awarding of prizes, a participant cannot win the same prize in two consecutive weeks. Under clause 2.5.3, they cannot win any weekly prize in consecutive weeks and can receive at most two weekly prizes during the Contest. A participant who does not meet these conditions is excluded from the weekly prize in question, without losing the possibility of continuing to collect Stars for the final ranking.",
        ],
      },
      {
        icon: "©️",
        heading: "5.1. Responsibility for content",
        items: [
          "5.1.1. Under no circumstances will Vodacom be responsible for content made available by participants on their social media profiles or by any other means, which is the sole responsibility of the participants, namely damage caused to the image, reputation and good name of third parties, without prejudice to legally applicable liabilities.",
          "5.1.2. Likewise, the use of brands, logos, designs, photographs, music, videos or any other elements protected by third-party industrial property rights, copyright or related rights in content produced and/or published by participants is their sole responsibility. Vodacom and the organisers of the QuizMaster Contest are not responsible for any infringement of intellectual and industrial property rights committed by participants, without prejudice to legally applicable liabilities.",
        ],
      },
      {
        icon: "🔒",
        heading: "5.2. Personal data",
        items: [
          "5.2.1. Participants expressly authorise Vodacom to process the personal data requested and provided in the context of the QuizMaster Contest, under the applicable Privacy Policy. The list of data to be collected, the specific purposes, the recipients and the retention periods shall be set out in the Contest privacy information.",
          "5.2.2. Participants guarantee that the personal data provided in the context of the QuizMaster Contest is true and accurate.",
          "5.2.3. Vodacom is the controller of the personal data collected. The collection and retention of personal data are subject to applicable law and are kept confidential, under the Privacy Policy.",
          "5.2.4. The personal data requested and provided during the Contest may also be used in marketing actions promoted by Vodacom, under the terms of the Privacy Policy and the applicable consents.",
          "5.2.5. With express consent, participants authorise Vodacom to use, publish, disclose and reproduce their name and image on the website and/or in advertising, promotion, publication or other media, for promotional, commercial or informative purposes in the context of the QuizMaster Contest, without payment of remuneration or compensation. The territorial and time scope and the mechanism for collecting this consent shall be confirmed before publication.",
          "5.2.6. Participation depends on the processing of the data needed to manage the Contest. Refusing to provide or allow the processing of that data makes participation impossible. The conditions of consent for marketing and use of image must be presented according to the applicable Privacy Policy.",
          "5.2.7. Vodacom's Privacy Policy is available at https://www.vm.co.mz/privacidade.",
        ],
      },
      {
        icon: "🤐",
        heading: "6. Confidentiality",
        items: [
          "6.1. Participants undertake to keep the utmost confidentiality regarding non-public information related to the QuizMaster Contest until it is publicly disclosed by the Promoter, namely regarding the start of the campaign, its duration, content, objectives, means, results before their disclosure and confidential indications or information given by the production team.",
          "6.2. Participants undertake to compensate the Promoter for losses caused by the early disclosure of such information, under applicable law.",
          "6.3. The confidentiality obligation does not cover these Rules, the public rankings, information already officially disclosed by the Promoter or the exercise of rights legally granted to participants.",
        ],
      },
      {
        icon: "📝",
        heading: "7. Changes to the Rules",
        items: [
          "7.1. Vodacom reserves the right to make changes to these Rules that it considers justified or necessary, provided they do not cause disproportionate inconvenience to participants, and undertakes to inform them of such changes through its official channels.",
          "7.2. Participants must accept the applicable changes to continue taking part in the QuizMaster Contest, failing which they will be excluded, without prejudice to legally applicable rights.",
        ],
      },
      {
        icon: "📌",
        heading: "8. Final provision",
        items: [
          "8.1. All questions on the interpretation of these Rules and cases not covered by them relating to the QuizMaster Contest will be analysed and clarified by the Promoter, Vodacom.",
          "8.2. The application of these Rules does not affect participants' rights under applicable law.",
        ],
      },
      {
        icon: "☎️",
        heading: "9. Contacts",
        items: [
          "9.1. Clarifications and further information about the Contest can be requested through the customer support line 84111, Vodacom's official social media or the address social.media@vm.co.mz.",
        ],
      },
    ],
  },
  3: {
    pageTitle: "Regulamento do Concurso",
    title: "Ganha Dinheiro no M-Pesa com QuizMaster",
    dates: "15 Out – 11 Nov 2026",
    back: "Voltar",
    play: "Jogar agora",
    leaderboard: "Classificação",
    footer:
      "A participação implica o conhecimento e a aceitação do presente Regulamento.",
    sections: [
      {
        icon: "📋",
        heading: "1. Aspectos gerais",
        items: [
          "1.1. O presente Regulamento estabelece as regras de participação no concurso «Ganha Dinheiro no M-Pesa com QuizMaster», adiante designado «Concurso», promovido pela Vodacom Moçambique, S.A., adiante designada «Vodacom» ou «Promotor». O QuizMaster é um produto da Vodacom, disponibilizado em parceria com a Raimboo.",
          "1.2. O QuizMaster é um serviço digital de perguntas e respostas sobre cultura geral e outros temas de conhecimento e entretenimento, disponibilizado pela Vodacom em parceria com a Raimboo. Os clientes respondem a perguntas, acumulam Estrelas e podem trocá-las por benefícios, de acordo com as condições habituais do serviço. Durante o Concurso, as Estrelas obtidas permitem também competir nos rankings semanal e final para ganhar prémios monetários no M-Pesa.",
          "1.3. O Concurso tem início previsto para 15 de Outubro de 2026, às 00h00, e termina em 11 de Novembro de 2026, às 23h59m59s, segundo a hora local de Moçambique. Para efeitos deste Regulamento, o mês promocional corresponde a 28 dias, divididos em quatro semanas consecutivas de sete dias, conforme o calendário abaixo.",
        ],
        table: {
          head: ["Semana", "Início", "Fim"],
          rows: [
            ["1", "15/10/2026 — 00h00", "21/10/2026 — 23h59m59s"],
            ["2", "22/10/2026 — 00h00", "28/10/2026 — 23h59m59s"],
            ["3", "29/10/2026 — 00h00", "04/11/2026 — 23h59m59s"],
            ["4", "05/11/2026 — 00h00", "11/11/2026 — 23h59m59s"],
          ],
        },
        itemsAfter: [
          "1.4. A participação implica o conhecimento e a aceitação do presente Regulamento. O Concurso complementa a mecânica habitual do QuizMaster, mantendo-se os preços, os pacotes adicionais, o ranking público e a troca normal de Estrelas, nos termos do serviço.",
        ],
      },
      {
        icon: "✅",
        heading: "2.1. Elegibilidade",
        items: [
          "2.1.1. Apenas números activos da Vodacom Moçambique são elegíveis para participar no Concurso. Podem participar clientes novos e clientes existentes do QuizMaster, incluindo clientes que regressem ao serviço, desde que cumpram as condições de participação.",
          "2.1.2. Não são elegíveis os membros das equipas directamente envolvidos na organização do Concurso.",
        ],
      },
      {
        icon: "📲",
        heading: "2.2. Inscrição e acesso",
        items: [
          "2.2.1. O participante pode aceder ao produto através de link: https://vmz.quizzzmaster.com ou iniciar a subscrição enviando uma SMS com a palavra «OK» para o número curto 84636, seguindo as instruções do serviço.",
          "2.2.2. A jornada de acesso compreende subscrição ou identificação, início de sessão e validação através de código de utilização única (OTP), de acordo com o fluxo disponibilizado pelo serviço.",
          "2.2.3. Após o acesso, o participante poderá responder às perguntas disponibilizadas no QuizMaster e acompanhar a sua pontuação e posição nos leaderboards semanal e final, disponíveis dentro do próprio produto.",
        ],
      },
      {
        icon: "💳",
        heading: "2.3. Preço e formas de pagamento",
        items: [
          "2.3.1. A subscrição diária do QuizMaster custa 3 MT, auto-renovável, e inclui 20 perguntas diárias.",
          "2.3.2. A subscrição semanal do QuizMaster custa 20 MT, auto-renovável.",
          "2.3.3. A subscrição mensal do QuizMaster custa 50 MT, auto-renovável.",
          "2.3.4. O participante pode adquirir pacotes adicionais de 10 perguntas pelo preço de 3 MT por pacote.",
          "2.3.5. O pagamento pode ser efectuado através do saldo de crédito Vodacom ou do M-Pesa, tanto na activação como na renovação e na aquisição de pacotes adicionais. A escolha de um destes meios de pagamento não altera a pontuação atribuída às respostas.",
        ],
      },
      {
        icon: "🎮",
        heading: "2.4. Funcionamento e pontuação",
        items: [
          "2.4.1. O Concurso é realizado através do QuizMaster, serviço digital de perguntas de conhecimento e entretenimento.",
          "2.4.2. Cada resposta correcta vale 10 Estrelas. Cada resposta incorrecta vale 1 estrela.",
          "2.4.3. Para efeitos do Concurso, são consideradas as Estrelas obtidas durante o respectivo período de classificação, incluindo as Estrelas de perguntas dos pacotes adicionais.",
          "2.4.4. A troca normal de Estrelas do QuizMaster mantém-se disponível. O Concurso utiliza as Estrelas obtidas nos períodos relevantes; a compatibilização técnica entre a troca de Estrelas e os registos dos rankings deverá ser confirmada antes do lançamento.",
        ],
      },
      {
        icon: "📊",
        heading: "2.5. Ranking semanal",
        items: [
          "2.5.1. O ranking semanal identifica os participantes com melhor pontuação obtida exclusivamente na respectiva semana de sete dias, de acordo com o calendário da cláusula 1.3. As Estrelas obtidas em semanas anteriores não contam para a classificação dessa semana. O ranking reinicia no início de cada nova semana.",
          "2.5.2. São premiados os cinco participantes elegíveis com maior pontuação em cada semana, de acordo com a tabela de prémios e a regra de repetição de vencedores.",
          "2.5.3. Cada participante pode ganhar, no máximo, dois prémios semanais durante as quatro semanas do Concurso e não pode ganhar prémios em semanas consecutivas.",
          "2.5.4. A impossibilidade de receber um prémio semanal por aplicação desta regra não impede o participante de continuar a jogar e a acumular Estrelas para o ranking final.",
          "2.5.5. Procedimento de atribuição dos prémios quando um participante do ranking não é elegível, incluindo a passagem ao participante seguinte e o valor correspondente à posição premiada.",
        ],
      },
      {
        icon: "🏁",
        heading: "2.6. Ranking final",
        items: [
          "2.6.1. O ranking final identifica os participantes com maior pontuação acumulada durante todo o mês promocional: de 15 de Outubro a 11 de Novembro de 2026. Soma as Estrelas obtidas nas quatro semanas de sete dias e não reinicia semanalmente.",
          "2.6.2. São premiados os três participantes elegíveis com maior pontuação acumulada no final do Concurso.",
          "2.6.3. Os vencedores semanais continuam elegíveis para o ranking final. O limite de dois prémios e a proibição de semanas consecutivas aplicam-se aos prémios semanais.",
          "2.6.4. Os vencedores semanais e os vencedores finais podem não ser os mesmos: os primeiros são apurados com base no desempenho na respectiva semana e os segundos com base no desempenho acumulado durante todo o mês promocional da campanha. Uma posição premiada numa semana não garante uma posição premiada na classificação final.",
        ],
      },
      {
        icon: "⚖️",
        heading: "2.7. Desempate",
        items: [
          "2.7.1. Em caso de igualdade de Estrelas no ranking semanal ou final, o desempate será determinado pelo tempo de resposta, tendo prioridade o participante que tenha respondido mais rapidamente, de acordo com os registos do QuizMaster.",
          "2.7.2. Método de cálculo do tempo de resposta e procedimento caso a igualdade persista também nesse critério.",
        ],
      },
      {
        icon: "🧑‍⚖️",
        heading: "2.8. Decisões",
        items: [
          "2.8.1. As decisões do Promotor relativas à aplicação do presente Regulamento e à validação dos resultados são finais no âmbito da organização do Concurso, sem prejuízo dos direitos legalmente aplicáveis aos participantes.",
          "2.8.2. Qualquer dúvida ou contestação deverá ser encaminhada através das redes sociais oficiais da Vodacom, da linha 84111 ou do endereço indicado na cláusula 9.",
        ],
      },
      {
        icon: "📣",
        heading: "2.9. Comunicação",
        items: [
          "2.9.1. As comunicações do Concurso poderão ser efectuadas por SMS, através do QuizMaster e dos canais oficiais da Vodacom. Os rankings e os anúncios de vencedores serão divulgados através dos canais definidos pelo Promotor.",
          "2.9.2. Os participantes devem garantir que os seus números de telefone estejam activos e acessíveis para receber comunicações relacionadas com o Concurso.",
          "2.9.3. Prazo de contacto dos vencedores, número de tentativas, prazo de resposta e procedimento relativo a vencedores não contactáveis é de 5 dias úteis depois da publicação.",
        ],
      },
      {
        icon: "🏅",
        heading: "2.10. Leaderboards dentro do produto",
        items: [
          "2.10.1. O QuizMaster disponibilizará, dentro do próprio produto, dois leaderboards distintos: um semanal e outro final.",
          "2.10.2. O leaderboard semanal apresenta a pontuação e a posição dos participantes na respectiva semana. O leaderboard final apresenta a pontuação acumulada e a posição dos participantes durante todo o mês promocional da campanha, correspondente às quatro semanas.",
          "2.10.3. A atribuição dos prémios depende da elegibilidade dos participantes e das regras de repetição de vencedores previstas neste Regulamento, e não apenas da posição apresentada no leaderboard.",
        ],
      },
      {
        icon: "💰",
        heading: "3.1. Prémios semanais",
        items: [
          "3.1.1. Em cada uma das quatro semanas serão atribuídos os seguintes prémios monetários no M-Pesa:",
        ],
        table: {
          head: ["Classificação", "Prémio no M-Pesa"],
          rows: [
            ["1.º lugar", "5.000 MT"],
            ["2.º lugar", "3.000 MT"],
            ["3.º lugar", "2.000 MT"],
            ["4.º lugar", "1.000 MT"],
            ["5.º lugar", "500 MT"],
          ],
        },
        itemsAfter: [
          "3.1.2. O valor total dos prémios semanais é de 11.500 MT por semana, correspondendo a 46.000 MT durante as quatro semanas.",
        ],
      },
      {
        icon: "🏆",
        heading: "3.2. Prémios finais",
        items: [
          "3.2.1. No encerramento do Concurso serão atribuídos os seguintes prémios monetários no M-Pesa:",
        ],
        table: {
          head: ["Classificação", "Prémio no M-Pesa"],
          rows: [
            ["1.º lugar", "20.000 MT"],
            ["2.º lugar", "15.000 MT"],
            ["3.º lugar", "10.000 MT"],
          ],
        },
        itemsAfter: [
          "3.2.2. O valor total dos prémios finais é de 45.000 MT. O valor global dos prémios do Concurso é de 91.000 MT.",
        ],
      },
      {
        icon: "📤",
        heading: "3.3. Entrega dos prémios",
        items: [
          "3.3.1. Os prémios monetários serão enviados para o M-Pesa dos vencedores até uma semana (sete dias) após o anúncio oficial dos respectivos vencedores.",
        ],
      },
      {
        icon: "🚫",
        heading: "4. Exclusão do desafio",
        items: [
          "4.1. O Promotor reserva-se o direito de excluir qualquer participante que defraude, dificulte, altere ou inutilize o bom funcionamento e o decurso normal e regular do Concurso QuizMaster, ou relativamente ao qual considere, com razoável grau de probabilidade, que não cumpriu o presente Regulamento, e/ou qualquer participante que coloque, ou possa colocar em causa, de forma directa ou indirecta, o bom nome ou a reputação da Vodacom, os seus direitos de propriedade industrial e/ou os seus colaboradores ou trabalhadores.",
          "4.2. Em qualquer caso, independentemente de terem sido ou não excluídos, os participantes serão exclusivamente responsáveis por todos os seus actos e omissões que sejam criminalmente puníveis, contrários à lei, susceptíveis de causar danos ou prejuízos a terceiros ou que violem os seus direitos de propriedade industrial, intelectual ou outros durante a sua participação no Concurso QuizMaster.",
          "4.3. A Vodacom não se responsabiliza pelas participações perdidas, atrasadas, incompletas, inválidas, extraviadas ou corrompidas, as quais não serão consideradas para efeitos de participação no Concurso, sem prejuízo das responsabilidades legalmente aplicáveis.",
          "4.4. A Vodacom não é responsável por transmissões electrónicas incompletas ou que tenham sofrido falhas, bem como por falhas técnicas de qualquer tipo, incluindo, mas não limitadas ao mau funcionamento de qualquer rede, hardware ou software, sem prejuízo das responsabilidades legalmente aplicáveis.",
          "4.5. Para efeitos de atribuição dos prémios, o participante não poderá ganhar o mesmo prémio em duas semanas consecutivas. Nos termos da cláusula 2.5.3, não poderá ganhar qualquer prémio semanal em semanas consecutivas e apenas poderá receber, no máximo, dois prémios semanais durante o Concurso. O participante que não cumpra estas condições fica excluído da atribuição do prémio semanal em causa, sem perder a possibilidade de continuar a acumular Estrelas para o ranking final.",
        ],
      },
      {
        icon: "©️",
        heading: "5.1. Responsabilização pelos conteúdos",
        items: [
          "5.1.1. Em nenhuma circunstância a Vodacom será responsável pelos conteúdos disponibilizados pelos participantes nos seus perfis nas redes sociais ou por qualquer outro meio, considerando-se que são da exclusiva responsabilidade destes últimos, designadamente os danos causados à imagem, reputação e bom nome de terceiros, sem prejuízo das responsabilidades legalmente aplicáveis.",
          "5.1.2. Da mesma forma, a utilização de marcas, logótipos, desenhos, fotografias, músicas, vídeos ou quaisquer outros elementos protegidos por direitos de propriedade industrial, direitos de autor ou direitos conexos de terceiros, em conteúdos produzidos e/ou divulgados pelos participantes, é da exclusiva responsabilidade destes. A Vodacom e as entidades organizadoras do Concurso QuizMaster não se responsabilizam por eventuais violações de direitos de propriedade intelectual e industrial cometidas pelos participantes, sem prejuízo das responsabilidades legalmente aplicáveis.",
        ],
      },
      {
        icon: "🔒",
        heading: "5.2. Dados pessoais",
        items: [
          "5.2.1. Os participantes autorizam expressamente o tratamento pela Vodacom dos dados pessoais solicitados e fornecidos no âmbito do Concurso QuizMaster, nos termos da Política de Privacidade aplicável. O elenco de dados a recolher, as finalidades específicas, os destinatários e os prazos de conservação deverão constar da informação de privacidade do Concurso.",
          "5.2.2. Os participantes garantem que os dados pessoais transmitidos no âmbito do Concurso QuizMaster são verdadeiros e exactos.",
          "5.2.3. O responsável pelo tratamento dos dados pessoais recolhidos é a Vodacom. A recolha e conservação dos dados pessoais ficam sujeitas à legislação aplicável e são asseguradas com confidencialidade, nos termos da Política de Privacidade.",
          "5.2.4. Os dados pessoais solicitados e fornecidos durante o Concurso poderão também ser utilizados em acções de marketing promovidas pela Vodacom, nos termos definidos na Política de Privacidade e dos consentimentos aplicáveis.",
          "5.2.5. Mediante consentimento expresso, os participantes autorizam a utilização, publicação, divulgação e reprodução do seu nome e da sua imagem pela Vodacom, no website e/ou em publicidade, promoção, publicação ou outros meios, com fins promocionais, comerciais ou informativos no âmbito do Concurso QuizMaster, sem pagamento de remuneração ou compensação. O âmbito territorial e temporal e o mecanismo de recolha deste consentimento deverão ser confirmados antes da publicação.",
          "5.2.6. A participação depende do tratamento dos dados necessários à gestão do Concurso. A recusa de fornecer ou permitir o tratamento desses dados inviabiliza a participação. As condições de consentimento para marketing e utilização da imagem devem ser apresentadas de acordo com a Política de Privacidade aplicável.",
          "5.2.7. A Política de Privacidade da Vodacom está disponível em https://www.vm.co.mz/privacidade.",
        ],
      },
      {
        icon: "🤐",
        heading: "6. Confidencialidade",
        items: [
          "6.1. Os participantes obrigam-se a manter a máxima confidencialidade relativamente às informações não públicas relacionadas com o Concurso QuizMaster até que sejam objecto de divulgação pública pelo Promotor, nomeadamente no que concerne ao início da campanha, à sua duração, conteúdo, objectivos, meios, resultados antes da sua divulgação e indicações ou informações confidenciais dadas pela equipa de produção.",
          "6.2. Os participantes obrigam-se a indemnizar o Promotor pelos prejuízos causados pela revelação antecipada dessas informações, nos termos legalmente aplicáveis.",
          "6.3. A obrigação de confidencialidade não abrange o presente Regulamento, os rankings públicos, as informações já divulgadas oficialmente pelo Promotor nem o exercício de direitos legalmente reconhecidos aos participantes.",
        ],
      },
      {
        icon: "📝",
        heading: "7. Alterações ao Regulamento",
        items: [
          "7.1. A Vodacom reserva-se o direito de introduzir alterações ao presente Regulamento que considere justificadas ou necessárias, desde que não causem transtorno desproporcionado aos participantes, assumindo a obrigação de os informar sobre as referidas alterações através dos seus canais oficiais.",
          "7.2. Os participantes deverão aceitar as alterações aplicáveis para continuar a participar no Concurso QuizMaster, sob pena de exclusão, sem prejuízo dos direitos legalmente aplicáveis.",
        ],
      },
      {
        icon: "📌",
        heading: "8. Disposição final",
        items: [
          "8.1. Todas as dúvidas sobre a interpretação e os casos omissos no presente Regulamento relativos ao Concurso QuizMaster serão analisados e esclarecidos pelo Promotor Vodacom.",
          "8.2. A aplicação do presente Regulamento não prejudica os direitos dos participantes previstos na legislação aplicável.",
        ],
      },
      {
        icon: "☎️",
        heading: "9. Contactos",
        items: [
          "9.1. Esclarecimentos e informações adicionais acerca do Concurso poderão ser solicitados através da linha de apoio ao cliente 84111, das redes sociais oficiais da Vodacom ou do endereço social.media@vm.co.mz.",
        ],
      },
    ],
  },
};

const PromoRules = () => {
  const navigate = useNavigate();
  const [language, setLanguage] = useState(
    localStorage.getItem("selectedLanguage") || "0",
  );
  const text = promoRulesText[language] || promoRulesText["0"];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layouts>
      <div className={rulesStyles.rulesPage}>
        <div className="container box-wrapper">
          {/* ===================== HEADER ===================== */}
          <div className={rulesStyles.rulesHeader}>
            <button
              type="button"
              className={rulesStyles.rulesBack}
              onClick={() => navigate(-1)}
            >
              <span aria-hidden="true">‹</span> {text.back}
            </button>

            <select
              className="choose-option"
              value={language}
              onChange={(event) => {
                setLanguage(event.target.value);
                localStorage.setItem("selectedLanguage", event.target.value);
              }}
            >
              <option value="0">English</option>
              <option value="3">Portuguese</option>
            </select>
          </div>

          {/* ===================== HERO ===================== */}
          <div className={rulesStyles.rulesHero}>
            <p className={rulesStyles.rulesPageTitle}>{text.pageTitle}</p>
            <h2 className={rulesStyles.rulesTitle}>{text.title}</h2>
            <span className={rulesStyles.rulesDates}>{text.dates}</span>
          </div>

          {/* ===================== SECTIONS ===================== */}
          {text.sections.map((section, index) => (
            <div className={rulesStyles.rulesSection} key={index}>
              <h3 className={rulesStyles.rulesHeading}>
                <span className={rulesStyles.rulesIcon} aria-hidden="true">
                  {section.icon}
                </span>
                {section.heading}
              </h3>
              <ul className={rulesStyles.rulesList}>
                {section.items.map((item, i) => (
                  <li key={i} className={rulesStyles.rulesItem}>
                    {item}
                  </li>
                ))}
              </ul>

              {/* ===================== OPTIONAL TABLE ===================== */}
              {section.table && (
                <div className={rulesStyles.rulesTableWrap}>
                  <table className={rulesStyles.rulesTable}>
                    <thead>
                      <tr>
                        {section.table.head.map((h, i) => (
                          <th key={i}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {section.table.rows.map((row, r) => (
                        <tr key={r}>
                          {row.map((cell, c) => (
                            <td key={c}>{cell}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {section.itemsAfter && (
                <ul className={rulesStyles.rulesList}>
                  {section.itemsAfter.map((item, i) => (
                    <li key={i} className={rulesStyles.rulesItem}>
                      {item}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}

          <p className={rulesStyles.rulesFooter}>{text.footer}</p>

          {/* ===================== ACTIONS ===================== */}
          <div className={rulesStyles.rulesActions}>
            <NavLink to="/promo/quiz" className={rulesStyles.rulesButton}>
              {text.play}
            </NavLink>
            <NavLink
              to="/promo/leaderboard"
              className={rulesStyles.rulesButtonOutline}
            >
              {text.leaderboard}
            </NavLink>
          </div>
        </div>
      </div>
    </Layouts>
  );
};

export default PromoRules;
